/*
We are handling the table sorting through use of the Mediator Pattern. In this
case, `Table` is the mediator and the `TH`s are the colleagues. `Table`
is in charge of which column is currently sorted, but all the `TH`s
need to change their behavior depending on this state.

To accomplish this we use the "compound component" pattern. For more info see
https://kentcdodds.com/blog/compound-components-with-react-hooks.
*/
import React from "react";
export const Context = /*#__PURE__*/React.createContext();
export function useColumnSortingContext() {
  const context = React.useContext(Context);

  if (!context) {
    throw new Error("This component can only be rendered as a child of a `Table` component.");
  }

  return context;
}